// AuthGuard.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// eslint-disable-next-line react/prop-types
const AuthGuard = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // const ID_DM900 = localStorage.getItem('ID_DM900');
    // const DS_EMAIL_LOGIN = localStorage.getItem('DS_EMAIL_LOGIN');
    // const NM_USUARIO = localStorage.getItem('NM_USUARIO');
    // if (!ID_DM900 || !DS_EMAIL_LOGIN || !NM_USUARIO) {
    //   navigate('/');
    // }
  }, [navigate]);

  return <>{children}</>;
};

export default AuthGuard;
